import { render, staticRenderFns } from "./Teams.vue?vue&type=template&id=600a25e6&scoped=true&"
import script from "./Teams.vue?vue&type=script&lang=ts&"
export * from "./Teams.vue?vue&type=script&lang=ts&"
import style0 from "./Teams.vue?vue&type=style&index=0&id=600a25e6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a25e6",
  null
  
)

export default component.exports